// useExportPdf.ts
import { useCallback } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export function useExportPdf(ref: React.RefObject<HTMLElement>) {
    return useCallback(async (title?: string) => {
        const node = ref.current;
        if (!node) return;

        // 1. 创建脱屏 iframe
        // 当 原来的 node 不在视图内时，需要创建一个脱屏 iframe 来截图
        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.left = "-9999px";
        iframe.style.top = "0";
        // 动态根据内容高度设置 iframe 高度
        const contentHeight = node.scrollHeight;
        iframe.width = "1200";
        iframe.height = String(contentHeight + 200);
        document.body.appendChild(iframe);

        const idoc = iframe.contentDocument!;
        idoc.open();
        idoc.write(`
            <html>
               <body>${node.outerHTML}</body>
            </html>
        `);
        idoc.close();

        // 2. 等待 iframe 内部资源加载
        await new Promise(res => setTimeout(res, 200));

        const innerNode = idoc.body.firstElementChild as HTMLElement;
        // 底部一定要有 padding，否则会出现底部截断问题
        innerNode.style.padding = "0 10px 10px 40px";

        // 3. 截图
        const canvas = await html2canvas(innerNode, {
            scale: 2,
            useCORS: true,
        });


        // 4. 生成 PDF
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(title ? `${title}.pdf` : "document.pdf");

        document.body.removeChild(iframe);
    }, [ref]);
}
